import { defineComponent as p, openBlock as r, createBlock as a, unref as l, mergeProps as m, withCtx as i, createElementVNode as e } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ p({
  name: "IconEmojiUnhappy",
  __name: "IconEmojiUnhappy",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, n) => (r(), a(l(c), m(t, { "view-box": "0 0 24 24" }), {
      default: i(() => [...n[0] || (n[0] = [
        e("path", { d: "M9.5 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M16.509 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7.868 4.516a.75.75 0 0 0 1.06 1.061 3.25 3.25 0 0 1 4.597 0 .75.75 0 0 0 1.06-1.06 4.75 4.75 0 0 0-6.717 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
